import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate, useRouter } from "@tanstack/react-router";
import { createUploadFilePriceUpdateUploadfilePost } from "@/client-admin";
import { Checkbox } from "@/components/ui/checkbox";
import { FileUploader } from "@/components/FileUploader";
import { checkSuperUserPermission } from "@/lib/utils";

export const Route = createFileRoute("/_superuser/admin/price-update/upload")({
  component: PriceUpdate,
  beforeLoad: () => {
    checkSuperUserPermission("price-update");
  },
});

function PriceUpdate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const router = useRouter();
  const [enableContractValidation, setEnableContractValidation] = useState(true);
  const { mutateAsync: uploadFile, isPending } = useMutation({
    mutationFn: async (files: File[]) => {
      const formData = {
        file: files[0],
      };
      await createUploadFilePriceUpdateUploadfilePost({ formData, enableContractValidation });

      router.invalidate();
      queryClient.invalidateQueries({ queryKey: ["price-update-route"] });
      navigate({ to: "/admin/price-update/review-upload" });
    },
  });

  return (
    <div className="container py-6">
      <div className="mb-4">
        <div className="flex items-start space-x-2">
          <Checkbox
            id="contract-validation"
            checked={enableContractValidation}
            onCheckedChange={(checked) => setEnableContractValidation(checked as boolean)}
          />
          <div className="grid gap-1.5 leading-none">
            <label
              htmlFor="contract-validation"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Enable Contract Validation
            </label>
            <p className="text-sm text-muted-foreground">
              When enabled, this will verify contract periods against the administratie.contracts table. You may want to
              disable this if you suspect the contracts table data might be outdated or incorrect.
            </p>
          </div>
        </div>
      </div>
      <FileUploader
        onUpload={uploadFile}
        accept={{ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [] }}
        maxSize={5 * 1024 * 1024} // 5MB
        isLoading={isPending}
      />
    </div>
  );
}
